/**
 * SokoTree Search JavaScript
 * Predictive search integration with Shopify Native Predictive Search API
 */

class SokoTreeSearchController {
  constructor() {
    this.modal = document.getElementById('SokoTreeSearchModal');
    this.openBtns = document.querySelectorAll('.js-search-modal-trigger');
    this.closeBtns = document.querySelectorAll('.js-search-modal-close');
    this.searchInput = document.querySelector('.js-predictive-search-input');
    this.resultsContainer = document.querySelector('.js-predictive-search-results');
    this.debounceTimer = null;

    this.bindEvents();
  }

  bindEvents() {
    this.openBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal();
      });
    });

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        const query = this.searchInput.value.trim();

        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.fetchPredictiveResults(query);
        }, 250);
      });
    }
  }

  openModal() {
    if (!this.modal) return;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-modal-open');
    setTimeout(() => {
      if (this.searchInput) this.searchInput.focus();
    }, 150);
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-modal-open');
  }

  resetResults() {
    if (!this.resultsContainer) return;
    this.resultsContainer.innerHTML = `
      <div class="search-initial-suggestions">
        <p class="suggestions-label">POPULAR SKINCARE CATEGORIES</p>
        <div class="category-tags-wrap">
          <a href="/collections/all" class="category-tag-pill">All Skincare</a>
          <a href="/collections/cleansers" class="category-tag-pill">Cleansers</a>
          <a href="/collections/serums" class="category-tag-pill">Serums</a>
          <a href="/collections/moisturizers" class="category-tag-pill">Moisturizers</a>
          <a href="/collections/toners" class="category-tag-pill">Toners</a>
          <a href="/collections/face-masks" class="category-tag-pill">Face Masks</a>
        </div>
      </div>
    `;
  }

  async fetchPredictiveResults(query) {
    if (!query || query.length < 2) {
      this.resetResults();
      return;
    }

    try {
      const url = `${window.SokoTree?.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=5&section_id=predictive-search`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('Search failed');
      const text = await res.text();

      if (this.resultsContainer) {
        if (text.trim().length > 0) {
          this.resultsContainer.innerHTML = text;
        } else {
          this.resultsContainer.innerHTML = `
            <div class="search-no-results-state">
              <p class="no-results-msg">No skincare products found for "${query}".</p>
              <a href="/search?q=${encodeURIComponent(query)}" class="sokotree-button button--secondary">View search page</a>
            </div>
          `;
        }
      }
    } catch (err) {
      console.error(err);
      if (this.resultsContainer) {
        this.resultsContainer.innerHTML = `
          <div class="search-no-results-state">
            <p class="no-results-msg">No skincare results found matching "${query}".</p>
          </div>
        `;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.SokoTreeSearch = new SokoTreeSearchController();
});
